import { Button } from "@sellar-io/components";
import { useNavigate } from "react-router";
import { Icon } from "../../../../../components";
import {
  getStorefrontLinkUrlParams,
  useStorefrontLinkSearchStore,
} from "../../../../storefrontLinks/StorefrontLinkSearchStore";

export const ProductCategorySharePricingButton = ({
  productId,
}: {
  productId: number;
}) => {
  const navigate = useNavigate();
  const {
    setSelectedProductId,
    setSelectedProductTab,
    setSelectedAudienceTab,
    setSelectedCustomerId,
    setPricingChecked,
  } = useStorefrontLinkSearchStore();
  return (
    <Button
      onClick={() => {
        setSelectedProductId(productId);
        setSelectedProductTab("specific");
        setSelectedAudienceTab("all");
        setSelectedCustomerId(undefined);
        setPricingChecked(false);
        navigate(
          getStorefrontLinkUrlParams({
            productId,
            selectedAudienceTab: "all",
            selectedProductTab: "specific",
            pricingChecked: false,
          }),
        );
      }}
    >
      <Icon icon={"SHARE"} />
      Share product
    </Button>
  );
};
